<template>
    <!-- 派对订单退款组件 -->
    <div>
        <a-modal
        centered
        :maskClosable="false"
        :destroyOnClose="true"
        title="新建退款"
        :visible="visible"
        @cancel="cancel"
        :width="650"
        :bodyStyle="{padding: 0}"
        :confirmLoading="confirmLoading"
        >
            <a-spin :spinning="spinning">
                <div class="pt16 pl16 pr16">
                    <a-alert v-if="disabledDatePicket" type="warning" show-icon>
                        <template slot="message">
                            <span class="font-small" style="color: #777;">若非录入今日退款，请联系总部运营进行补录</span>
                        </template>
                    </a-alert>
                    <a-row class="mt16">
                        <a-col :span="12">订单号：{{detailData.id}}</a-col>
                        <a-col :span="12">派对日期：{{detailData.partyDate}}</a-col>
                    </a-row>
                    <a-row class="mt16">
                        <a-col :span="12">派对门店：{{detailData.shopName}}</a-col>
                        <a-col :span="12">客户名称：{{detailData.customerName}}</a-col>
                    </a-row>
                    <a-row class="mt16">
                        <a-col :span="12">客户手机号：{{detailData.customerPhone}}</a-col>
                        <a-col :span="12">派对负责人：{{detailData.partyStaff}}</a-col>
                    </a-row>
                    <a-alert class="mt16" :show-icon="false" banner>
                        <template slot="message">
                            <div class="text-center">
                                <a-row class="mb8">
                                    <a-col :span="8">预售金额（元）</a-col>
                                    <a-col :span="8">实收金额（元）</a-col>
                                    <a-col :span="8">剩余预计应收金额（元）</a-col>
                                </a-row>
                                <a-row>
                                    <a-col :span="8">{{detailData.totalPresell | myToFixed2 | thousandFormat}}</a-col>
                                    <a-col :span="8">{{detailData.payment | myToFixed2 | thousandFormat}}</a-col>
                                    <a-col :span="8" class="text-fail">{{(detailData.totalPresell - detailData.payment) | myToFixed2 | thousandFormat}}</a-col>
                                </a-row>
                            </div>
                        </template>
                    </a-alert>
                </div>
                <a-divider class="mt16 mb16"></a-divider>
                <a-form :form="form">
                    <a-form-item label="退款金额" :label-col="{span: 8}" :wrapper-col="{span: 12}">
                        <a-input-number style="width: 100%;" v-decorator="['amount', {rules: [{required: true, message: '请输入'}, {pattern: /^(\d*)([.]{1}\d{1,2}?)?$/, message: '退款金额需大于等于0'}]}]" placeholder="请输入，退款金额需大于等于0"></a-input-number>
                    </a-form-item>
                    <a-form-item label="退款方式" :label-col="{span: 8}" :wrapper-col="{span: 12}">
                        <a-select allowClear :options="$commonOptions.refundModeStrOptions" v-decorator="['mode', {rules: [{required: true, message: '请选择'}]}]" placeholder="请选择"></a-select>
                    </a-form-item>
                    <a-form-item label="退款日期" :label-col="{span: 8}" :wrapper-col="{span: 12}">
                        <a-date-picker allowClear :disabled="disabledDatePicket" style="width: 100%;" v-decorator="['actionDate', {rules: [{required: true, message: '请选择'}]}]" placeholder="请选择"></a-date-picker>
                    </a-form-item>
                    <a-form-item label="附件上传" :label-col="{span: 8}" :wrapper-col="{span: 12}">
                        <imagesUploader ref="imagesUploader" listType="text"></imagesUploader>
                    </a-form-item>
                    <a-form-item label="备注" :label-col="{span: 8}" :wrapper-col="{span: 12}">
                        <a-textarea style="width: 100%; resize: none; height: 80px;" v-decorator="['remark', {rules: [{required: true, message: '请输入（10-50字）'}, {pattern: /(^.{0}$)|(^.{10,50}$)/, message: '请输入（10-50字）'}]}]" placeholder="请输入（10-50字）"></a-textarea>
                    </a-form-item>
                </a-form>
            </a-spin>
            <template slot="footer">
                <a-button @click="cancel">取消</a-button>
                <a-popconfirm
                    title="是否确认提交？"
                    ok-text="确认"
                    cancel-text="取消"
                    @confirm="ok"
                >
                    <a-button :loading="confirmLoading" type="primary">确定</a-button>
                </a-popconfirm>
            </template>
        </a-modal>
    </div>
</template>

<script>
    import imagesUploader from '@/components/common/images-uploader.component';
    export default {
        name: "partyOrderRefund",
        zh: "派对订单退款",
        components: {
            imagesUploader
        },
        props: {
        },
        data() {
            return {
                visible: false,
                spinning: false,
                confirmLoading: false,
                disabledDatePicket: true,
                orderId: null,
                detailData: {}
            }
        },
        computed: {},
        watch: {

        },
        methods: {
            open(isRepair, orderId) {
                this.visible = true;
                this.$nextTick(() => {
                    this.orderId = orderId;
                    this.getDetail();
                    this.disabledDatePicket = !isRepair;
                    this.form.setFieldsValue({
                        actionDate: this.$moment()
                    });
                });
            },
            ok() {
                this.form.validateFields((errors, values) => {
                    if (Boolean(errors) || this.confirmLoading) {
                        return false;
                    };
                    values.actionDate = values.actionDate.format('YYYY-MM-DD');
                    let fileList = this.$refs.imagesUploader.fileList;
                    if (fileList.length > 0) {
                        values.files = fileList.map(i => {
                            return ({
                                name: i.name,
                                ossUrl: i.url,
                                thumbnailOssUrl: i.url + '?x-oss-process=image/resize,m_fill,h_100,w_100'
                            });
                        })
                    }
                    let apiKey = ['partyOrderRefundSave0', 'partyOrderRefundSave1'];
                    this.confirmLoading = true;
                    this.$api.order[apiKey[Number(!this.disabledDatePicket)]]({
                        body: {
                            orderId: this.orderId,
                            ...values
                        }
                    }).then(res => {
                        this.confirmLoading = false;
                        this.$message.success('操作成功！');
                        this.cancel();
                    }).catch(err => {
                        this.confirmLoading = false;
                    })
                });
            },
            cancel() {
                this.visible = false;
                this.$emit('cancel');
            },
            /**
             * @func getDetail 获取订单详情
             */
            getDetail() {
                this.spinning = true;
                this.$api.order.partyOrderDetail({
                    params: {
                        id: this.orderId
                    }
                }).then(res => {
                    this.detailData = res;
                    this.spinning = false;
                });
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        updated() {},
        mounted() {},
    };
</script>

<style lang="scss">
</style>
